<template>
  <div class="fixed top-0 left-0 h-full w-full bg-white-80 flex items-center justify-center z-20">
    <div class="flex flex-col items-center">
      <div class="flex">
        <div>{{ message }}</div>
        <div class="w-0">{{ dots() }}</div>
      </div>
      <div class="mt-4">
        <div class="w-64 h-12 border border-gray-400 text-center items-center justify-center relative rounded bg-white">
          <div class="absolute text-center h-full w-full flex items-center justify-center text-gray-700">
            <span>{{ percText }}</span>
          </div>
          <div class="h-full bg-green-400 rounded" :style=barStyle></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'Loading',
    },
    val: {
      default: 0,
    },
    max: {
      default: 100,
    },
  },
  computed: {
    barStyle() {
      const width = this.percentage * 0.159;
      return {
        width: `${width}rem`,
      };
    },
    percText() {
      if (this.percentage == 100) {
        return 'Download complete!'
      }
      return `${this.percentage}%`;
    },
    percentage() {
      let perc = (this.val/this.max)*100;
      perc = perc.toFixed(2);
      return Math.min(perc, 100);
    },
  },
  data() {
    return {
      nDots: 3,
    };
  },
  methods: {
    updateDots() {
      this.nDots = (this.nDots + 1) % 4;
    },
    dots() {
      return '.'.repeat(this.nDots);
    },
    startInterval() {
      setInterval(() => { this.updateDots(); }, 1000);
    },
  },
  mounted() {
    this.startInterval();
  },
};
</script>
